import moment from 'moment-timezone';

const unknownDate = 'unknown date'

export function toGbpCurrency(amount) {
    return amount.toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP'
    })
}

export function toDate(date) {
    const submittedDate = new Date(date)

    return submittedDate.toLocaleDateString('en-GB')
}
export function formatDateWithOffset(date) {
    const tzOffsetMinutes = -date.getTimezoneOffset()
    const sign = tzOffsetMinutes >= 0 ? '+' : '-'
    const hoursOffset = String(Math.floor(Math.abs(tzOffsetMinutes) / 60)).padStart(2, '0')
    const minutesOffset = String(Math.abs(tzOffsetMinutes) % 60).padStart(2, '0')

    const localDateTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 19) // Remove milliseconds and 'Z'

    return `${localDateTime}${sign}${hoursOffset}:${minutesOffset}`
}


const formatDateBase = (dateString, format) => {

    if (!dateString) {
        return unknownDate
    }

    const date = moment(dateString)

    const year = date.year()
    if (year < 1000) {
        return unknownDate
    }

    return date.format(format)
}

export function formatDateMonth(dateString) {
    return formatDateBase(dateString, 'Do MMMM YYYY')

}
export function formatDateMonthTime(dateString) {

    return formatDateBase(dateString, 'HH:mm Do MMMM YYYY')
}


export function moveEntryToTop(customlist, targetId) {
    // Find the index of the entry with id = targetId
    const index = customlist.findIndex(item => item.id === targetId)

    if (index !== -1) {
        // Remove the entry from its original position
        const [entry] = customlist.splice(index, 1)
        // Add the entry to the top of the list
        customlist.unshift(entry)
    }
    return customlist
}

export function convertMinutesToDuration(minutes) {
    const hours = Math.floor(minutes / 60)
    const mins = minutes % 60
    return `${hours}h ${mins}m`
}
